import API from "./API";
import app from "../stores/app";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        initialize: () => API.GET('initialize'),
        tour_details: (id) => API.POST(`tour/details`, {id}),
    },

    transfer: {
        loadPrices: (data) => API.POST(`transfer/prices`, data),
        details: (code) => API.POST(`transfer/details`, {code}),
    },

    reservation: {
        create: (data) => API.POST(`reservation/create`, data),
        details: (hash) => API.POST(`reservation/details`, {hash}),
        checkout: (hash) => API.POST(`reservation/checkout`, {hash}),
    },

};

export default R;
// export {mm as requestingStore};